import { render } from "./ProductOrCategoryTabsModal.vue?vue&type=template&id=46818bd6&scoped=true"
import script from "./ProductOrCategoryTabsModal.vue?vue&type=script&lang=js"
export * from "./ProductOrCategoryTabsModal.vue?vue&type=script&lang=js"

import "./ProductOrCategoryTabsModal.vue?vue&type=style&index=0&id=46818bd6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46818bd6"]])

export default __exports__